const url = {
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL || "https://q4ybqywn09.execute-api.eu-central-1.amazonaws.com/dev",
};

// https://8nio0ndet6.execute-api.eu-central-1.amazonaws.com/stage
// https://q4ybqywn09.execute-api.eu-central-1.amazonaws.com/dev

const config = url;

export const { REACT_APP_BASE_URL } = config;
